import TrendDownRedSvg from '@assets/icons/Arrow-Thick-Circle-Down-Red.svg?react'
import TrendDownYellowSvg from '@assets/icons/Arrow-Thick-Circle-Down-Yellow.svg?react'
import TrendDownGreenSvg from '@assets/icons/Arrow-Thick-Circle-Down.svg?react'
import TrendUpGreenSvg from '@assets/icons/Arrow-Thick-Circle-Up-Green.svg?react'
import TrendUpYellowSvg from '@assets/icons/Arrow-Thick-Circle-Up-Yellow.svg?react'
import TrendUpRedSvg from '@assets/icons/Arrow-Thick-Circle-Up.svg?react'
import OptimierungSvg from '@assets/icons/Optimierung.svg?react'
import ShoppingCartEnergySvg from '@assets/icons/shopping-cart-energy.svg?react'

import { DiagrammIcon } from '@/src/components/Icons/Diagramm.icon'
import { SankeyIcon } from '@/src/components/Icons/Sankey.icon'
import { TabelleIcon } from '@/src/components/Icons/Tabelle.icon'

import GearSvg from '@assets/icons/gear.svg?react'
import IconLocationGroupSvg from '@assets/icons/icon_location_group.svg?react'
import ChatMessagesSvg from '@assets/icons/loader-types/chat-messages.svg?react'
import SearchColorSvg from '@assets/icons/loader-types/search-color.svg?react'
import GreenPlusIconSvg from '@assets/icons/plus.svg?react'
import MessageSquareMoreSvg from '@assets/icons/message-square-more.svg?react'
import EcoplanetSendArrowSvg from './ecoplanet-send-arrow.svg?react'
import SendSvg from '@assets/icons/send.svg?react'
import XCircleSvg from '@assets/icons/x_circled.svg?react'
import { Icon, type IconProps, Image } from '@chakra-ui/react'
import { ChevronDown, ChevronRight } from 'react-feather'
import AlertSvg from './alert.svg?react'
import BarGraphIconSvg from './bar-graph-icon.svg?react'
import CheckmarkCircledSvg from './checkmark-circled.svg?react'
import CircleDashedSvg from './circle-dashed.svg?react'
import CloseIconSvg from './close2.svg?react'
import DatabaseSvg from './database.svg?react'
import DocumentsIconSvg from './documents.svg?react'
import DragHandleSixDotsSvg from './drag-handle-six-dots.svg?react'
import EcoplanetFileSvg from './ecoplanet-file.svg?react'
import PickaxeSvg from '@assets/icons/pickaxe.svg?react'

import CsvSvg from './file-icons/csv.svg?react'
import DocSvg from './file-icons/doc.svg?react'
import DocxSvg from './file-icons/docx.svg?react'
import EcoSvg from './file-icons/eco.svg?react'
import JpgSvg from './file-icons/jpg.svg?react'
import LinkSvg from './file-icons/link.svg?react'
import LinkIconSvg from './link.svg?react'
import UnlinkIconSvg from './unlink.svg?react'
import PdfSvg from './file-icons/pdf.svg?react'
import PngSvg from './file-icons/png.svg?react'
import PptSvg from './file-icons/ppt.svg?react'
import PptxSvg from './file-icons/pptx.svg?react'
import TxtSvg from './file-icons/txt.svg?react'
import XlsSvg from './file-icons/xls.svg?react'
import XlsxSvg from './file-icons/xlsx.svg?react'
import FileUploadSvg from './file-upload.svg?react'
import FileSvg from './file.svg?react'
import HierarchySvg from './hierarchy.svg?react'
import InfoIconSvg from './info.svg?react'
import LightningBoltOutlineSvg from './lightning-bolt-outline.svg?react'
import LineGraphIconSvg from './line-graph-icon.svg?react'
import PencilIconSvg from './pencil.svg?react'
import TableFilterSvg from './table-filter.svg?react'
import TargetSvg from './target.svg?react'
import UploadLogoSvg from './upload.svg?react'
import SupportSvg from './support.svg?react'
import EnergyCostSvg from './energy-cost.svg?react'
import EcoplanetLogoSvg from './ecoplanet-logo.svg?react'
import EcoplanetLettermarkLogoSvg from './ecoplanet-lettermark-logo.svg?react'
import ChartColumnSvg from './chart-column.svg?react'
import CircleFadingPlusSvg from './circle-fading-plus.svg?react'
import SparkleSvg from './sparkle.svg?react'
import ArrowDownUpSvg from './arrow-down-up.svg?react'
import UserRoundSearchSvg from './user-round-search.svg?react'
import SearchExclamationSvg from './search-exclamation.svg?react'
import LightbulbSvg from './lightbulb.svg?react'

import ChartAreaSvg from './chart-area.svg?react'
import EcoplanetTriangleAlertSvg from './ecoplanet-triangle-alert.svg?react'


import ElectricitySvg from '@assets/icons/energy-circle-icons/electricity.svg?react'
import FluidGasSvg from '@assets/icons/energy-circle-icons/fluid-gas.svg?react'
import FuelsSvg from '@assets/icons/energy-circle-icons/fuels.svg?react'
import GasSvg from '@assets/icons/energy-circle-icons/gas.svg?react'
import PressurizedAirSvg from '@assets/icons/energy-circle-icons/pressurized-air.svg?react'
import VirtualMeterSvg from '@assets/icons/energy-circle-icons/virtual-meter.svg?react'
import HeatingSvg from '@assets/icons/energy-circle-icons/heating.svg?react'
import WaterSvg from '@assets/icons/energy-circle-icons/water.svg?react'

import ElectricityOutlineSvg from '@assets/icons/energy-sources-outlined/electricity-outline.svg?react'
import FluidGasOutlineSvg from '@assets/icons/energy-sources-outlined/fluid-gas-outline.svg?react'
import FuelsOutlineSvg from '@assets/icons/energy-sources-outlined/fuels-outline.svg?react'
import GasOutlineSvg from '@assets/icons/energy-sources-outlined/gas-outline.svg?react'
import PressurizedAirOutlineSvg from '@assets/icons/energy-sources-outlined/pressurized-air-outline.svg?react'
import VirtualMeterOutlineSvg from '@assets/icons/energy-sources-outlined/virtual-meter-outline.svg?react'
import HeatingOutlineSvg from '@assets/icons/energy-sources-outlined/heating-outline.svg?react'
import WaterOutlineSvg from '@assets/icons/energy-sources-outlined/water-outline.svg?react'

import ManualMeterMonthlyConsumptionUiSvg from '@assets/icons/manual-meter/monthly-consumption-ui.svg?react'
import ManualMeterMeterReadingUiSvg from '@assets/icons/manual-meter/meter-reading-ui.svg?react'

const IconPng = ({ src, ...props }) => <Image src={src} boxSize='1em' objectFit='cover' {...props} />

export const InfoIcon = props => <Icon as={InfoIconSvg} {...props} />
export const EfficiencyAndMeasuresIcon = props => <Icon as={OptimierungSvg} {...props} />

// energy sources icons
export const ElectricityIcon = props => <IconPng src={ElectricitySvg} {...props} />
export const GasIcon = props => <IconPng src={GasSvg} {...props} />
export const PressurizedAirIcon = props => <Icon as={PressurizedAirSvg} {...props} />
export const HeatingIcon = props => <Icon as={HeatingSvg} {...props} />

// energy circle icons
export const FuelsCircleIcon = (props: IconProps) => <Icon as={FuelsSvg} {...props} />
export const GasCircleIcon = (props: IconProps) => <Icon as={GasSvg} {...props} />
export const HeatingCircleIcon = (props: IconProps) => <Icon as={HeatingSvg} {...props} />
export const FluidGasCircleIcon = (props: IconProps) => <Icon as={FluidGasSvg} {...props} />
export const PressurizedAirCircleIcon = (props: IconProps) => <Icon as={PressurizedAirSvg} {...props} />
export const WaterCircleIcon = (props: IconProps) => <Icon as={WaterSvg} {...props} />
export const ElectricityCircleIcon = (props: IconProps) => <Icon as={ElectricitySvg} {...props} />
export const VirtualMeterCircleIcon = (props: IconProps) => <Icon as={VirtualMeterSvg} {...props} />


export const GasOutlineIcon = props => <Icon as={GasOutlineSvg} {...props} />
export const PressurizedAirOutlineIcon = props => <Icon as={PressurizedAirSvg} {...props} />
export const LightningBoltOutlineIcon = props => <Icon as={LightningBoltOutlineSvg} {...props} />

export const DatabaseIcon = props => <Icon as={DatabaseSvg} {...props} />
export const EnergyCostIcon = props => <Icon as={EnergyCostSvg} {...props} />

// trend icons
export const TrendUpGreen = props => <Icon as={TrendUpGreenSvg} {...props} />
export const TrendDownGreen = props => <Icon as={TrendDownGreenSvg} {...props} />
export const TrendUpRed = props => <Icon as={TrendUpRedSvg} {...props} />
export const TrendDownRed = props => <Icon as={TrendDownRedSvg} {...props} />
export const TrendUpYellow = props => <Icon as={TrendUpYellowSvg} {...props} />
export const TrendDownYellow = props => <Icon as={TrendDownYellowSvg} {...props} />

// File icons
export const CsvIcon = props => <Icon as={CsvSvg} {...props} />
export const PdfIcon = props => <Icon as={PdfSvg} {...props} />
export const PptIcon = props => <Icon as={PptSvg} {...props} />
export const XlsIcon = props => <Icon as={XlsSvg} {...props} />
export const DocIcon = props => <Icon as={DocSvg} {...props} />
export const JpgIcon = props => <Icon as={JpgSvg} {...props} />
export const TxtIcon = props => <Icon as={TxtSvg} {...props} />
export const PptxIcon = props => <Icon as={PptxSvg} {...props} />
export const XlsxIcon = props => <Icon as={XlsxSvg} {...props} />
export const DocxIcon = props => <Icon as={DocxSvg} {...props} />
export const PngIcon = props => <Icon as={PngSvg} {...props} />
export const EcoIcon = props => <Icon as={EcoSvg} {...props} />
export const LinkIcon = props => <Icon as={LinkSvg} {...props} />
export const DocumentsIcon = props => <Icon as={DocumentsIconSvg} {...props} />

export const IconLocationGroup = props => <Icon as={IconLocationGroupSvg} {...props} />
export const GearIcon = props => <Icon as={GearSvg} {...props} />
export const GreenPlusIcon = props => <Icon as={GreenPlusIconSvg} {...props} />
export const EcoplanetFileIcon = (props: IconProps) => <Icon as={EcoplanetFileSvg} {...props} />

export const FileIcon = (props: IconProps) => <Icon as={FileSvg} {...props} />
export const FileUploadIcon = (props: IconProps) => <Icon as={FileUploadSvg} {...props} />
export const CheckmarkCircledIcon = (props: IconProps) => <Icon as={CheckmarkCircledSvg} {...props} />
export const CircleDashedIcon = (props: IconProps) => <Icon as={CircleDashedSvg} {...props} />
export const AlertIcon = (props: IconProps) => <Icon as={AlertSvg} {...props} />
export const CloseIcon = (props: IconProps) => <Icon as={CloseIconSvg} {...props} />
export const HierarchyIcon = (props: IconProps) => <Icon as={HierarchySvg} {...props} />
export const TableFilterIcon = (props: IconProps) => <Icon as={TableFilterSvg} {...props} />
export const PickaxeIcon = (props: IconProps) => <Icon as={PickaxeSvg} {...props} />

export const ManualMeterMeterReadingUiIcon = (props: IconProps) => <Icon as={ManualMeterMeterReadingUiSvg} {...props} />
export const ManualMeterMonthlyConsumptionUiIcon = (props: IconProps) => <Icon as={ManualMeterMonthlyConsumptionUiSvg} {...props} />

type SparkleIconProps = IconProps & {
  fillColor?: string
}

export const SparkleIcon = ({ fillColor, color, ...props }: SparkleIconProps) => (
  <Icon as={SparkleSvg} color={color ?? fillColor} {...props} />
)

export const UploadLogo = ({
  backgroundColor = 'white',
  borderColor = 'gray',
  arrowColor = 'currentColor',
  arrowBaseColor = 'currentColor',
  ...props
}) => (
  <Icon
    as={UploadLogoSvg}
    {...props}
    sx={{
      '& path.background': {
        fill: backgroundColor,
      },
      '& path.arrow': {
        fill: arrowColor,
      },
      '& path.arrow-base': {
        fill: arrowBaseColor,
      },
    }}
  />
)

export const SupportIcon = props => <Icon as={SupportSvg} {...props} />
export const SearchExclamationIcon = (props: IconProps) => <Icon as={SearchExclamationSvg} {...props} />
export const LightbulbIcon = (props: IconProps) => <Icon as={LightbulbSvg} {...props} />

const iconMap = {
  trendDownRed: TrendDownRedSvg,
  trendDownYellow: TrendDownYellowSvg,
  trendDownGreen: TrendDownGreenSvg,
  trendUpGreen: TrendUpGreenSvg,
  trendUpYellow: TrendUpYellowSvg,
  trendUpRed: TrendUpRedSvg,
  gear: GearSvg,

  close: CloseIconSvg,
  ['x_circled']: XCircleSvg,
  plus: GreenPlusIconSvg,
  chevronDown: ChevronDown,
  diagramm: DiagrammIcon,
  sankey: SankeyIcon,
  tabelle: TabelleIcon,
  lineGraph: LineGraphIconSvg,
  barGraph: BarGraphIconSvg,
  chevronRight: ChevronRight,
  support: SupportSvg,
  ecoplanetFile: EcoplanetFileSvg,


  // Energy types icons
  electricity: ElectricitySvg,
  fluidGas: FluidGasSvg,
  fuels: FuelsSvg,
  gas: GasSvg,
  heating: HeatingSvg,
  pressurizedAir: PressurizedAirSvg,
  virtualMeterGroup: VirtualMeterSvg,
  water: WaterSvg,

  // Outlined icons
  electricityOutline: ElectricityOutlineSvg,
  fluidGasOutline: FluidGasOutlineSvg,
  fuelsOutline: FuelsOutlineSvg,
  gasOutline: GasOutlineSvg,
  heatingOutline: HeatingOutlineSvg,
  pressurizedAirOutline: PressurizedAirOutlineSvg,
  virtualMeterOutline: VirtualMeterOutlineSvg,
  waterOutline: WaterOutlineSvg,

  // Icons for Ecoplant Logo
  ecoplanetLogo: EcoplanetLogoSvg,
  ecoplanetLettermarkLogo: EcoplanetLettermarkLogoSvg,

  // Custom Lucide-inspired icons
  chartColumn: ChartColumnSvg,
  circleFadingPlus: CircleFadingPlusSvg,
  link: LinkIconSvg,
  unlink: UnlinkIconSvg,
  info: InfoIconSvg,
}

type BaseIconProps = {
  name: keyof typeof iconMap
  [key: string]: any
}

// TODO: Extend with all Figma icons and make this the default way to use icons
const BaseIcon = ({ name, ...props }: BaseIconProps) => {
  const IconComponent = iconMap[name]

  if (!IconComponent) {
    console.warn(`Icon "${name}" does not exist in the icon map.`)
    return null
  }

  return typeof IconComponent === 'string' ? (
    <Image src={IconComponent} boxSize='1em' objectFit='cover' {...props} />
  ) : (
    <Icon as={IconComponent} {...props} />
  )
}

export default BaseIcon
export const TargetIcon = (props: IconProps) => <Icon as={TargetSvg} {...props} />
export const DragHandleSixDotsIcon = (props: IconProps) => <Icon as={DragHandleSixDotsSvg} {...props} />
export const PencilIcon = (props: IconProps) => <Icon as={PencilIconSvg} {...props} />
export const SendMessageIcon = (props: IconProps) => <Icon as={SendSvg} {...props} />
export const EcoplanetSendArrowIcon = (props: IconProps) => <Icon as={EcoplanetSendArrowSvg} {...props} />
export const MessageSquareMoreIcon = (props: IconProps) => <Icon as={MessageSquareMoreSvg} {...props} />
export const ChatMessagesIcon = (props: IconProps) => <Icon as={ChatMessagesSvg} {...props} />
export const SearchColorIcon = (props: IconProps) => <Icon as={SearchColorSvg} {...props} />
export const ShoppingCartEnergyIcon = (props: IconProps) => <Icon as={ShoppingCartEnergySvg} {...props} />
export const ArrowDownUpIcon = (props: IconProps) => <Icon as={ArrowDownUpSvg} {...props} />
export const UserRoundSearchIcon = (props: IconProps) => (
  <Icon as={UserRoundSearchSvg} sx={{ path: { stroke: 'currentColor' } }} {...props} />
)

export const ChartAreaIcon = (props: IconProps) => <Icon as={ChartAreaSvg} {...props}/>
export const EcoplanetTriangleAlertIcon = (props: IconProps) => <Icon as={EcoplanetTriangleAlertSvg} {...props} />

import EcoplanetXSvg from './ecoplanet-x.svg?react'
export const EcoplanetXIcon = (props: IconProps) => <Icon as={EcoplanetXSvg} {...props} />

import EcoplanetSearchXSvg from './ecoplanet-search-x.svg?react'
export const EcoplanetSearchXIcon = (props: IconProps) => <Icon as={EcoplanetSearchXSvg} {...props} />

import EcoplanetEmptyGraphicSvg from './ecoplanet-empty-graphic.svg?react'
export const EcoplanetEmptyGraphicIcon = (props: IconProps) => <Icon as={EcoplanetEmptyGraphicSvg} {...props} />

import ReportTeaserModulesSvg from './report-teaser-modules.svg?react'
export const ReportTeaserModulesIcon = (props: IconProps) => <Icon as={ReportTeaserModulesSvg} {...props} />

import ReportTeaserTemplatesSvg from './report-teaser-templates.svg?react'
export const ReportTeaserTemplatesIcon = (props: IconProps) => <Icon as={ReportTeaserTemplatesSvg} {...props} />

import ReportTeaserTemplatesHoverSvg from './report-teaser-templates-hover.svg?react'
export const ReportTeaserTemplatesHoverIcon = (props: IconProps) => <Icon as={ReportTeaserTemplatesHoverSvg} {...props} />

import ReportUpgradeBadgeSvg from './report-upgrade-badge.svg?react'
export const ReportUpgradeBadgeIcon = (props: IconProps) => <Icon as={ReportUpgradeBadgeSvg} {...props} />

export { default as IconChevronDown } from './chevron-down.svg?react'
export { default as ChevronLeftButton } from './chevron-left-button.svg?react'
export { default as ChevronRightButton } from './chevron-right-button.svg?react'
export { default as TrashIcon } from './trash.svg?react'
export { default as ChevronsDoubleUp } from './chevrons-double-up.svg?react'
export { default as ChevronsTripleUp } from './chevrons-triple-up.svg?react'
export { default as ChevronsUp } from './chevrons-up.svg?react'
export { default as SignalLowIcon } from './signal-low.svg?react'
export { default as SignalMediumIcon } from './signal-medium.svg?react'
export { default as SignalHighIcon } from './signal-high.svg?react'
export { default as AskEmberIcon } from '@assets/icons/ask-ember.svg?react'
export { default as DownPointIcon } from '@assets/icons/Down-Point.svg?react'
export { default as UpPointIcon } from '@assets/icons/Up-Point.svg?react'
